import type { ReactElement } from "react";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { StyledNewAssetButtonWrapper } from "./styles";
import NewAssetButtonTracked from "app/pages/sales-intelligence/pages/home/containers/NewAssetButton/NewAssetButtonTracked";
import { translate } from "app/filters/i18nFilter";
import TutorialViewTracked from "app/pages/sales-intelligence/pages/home/containers/TutorialView/TutorialViewTracked";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";

interface Props {
    onUploadCsv: () => void;
    metadata: ViewModelMetadata;
}

const CSVEnrichmentButtonsView = ({ metadata, onUploadCsv }: Props): ReactElement => {
    return (
        <FlexRow>
            <StyledNewAssetButtonWrapper>
                <NewAssetButtonTracked
                    metadata={metadata}
                    onClick={onUploadCsv}
                >
                    {translate("si.my-lists.section.enrichment.dropdown.option_1")}
                </NewAssetButtonTracked>
            </StyledNewAssetButtonWrapper>

            <TutorialViewTracked
                metadata={metadata}
                stateId="salesIntelligence-home-csvEnrichment"
            >
                {translate("si.pages.home.card.action.tutorial")}
            </TutorialViewTracked>
        </FlexRow>
    );
}

export default CSVEnrichmentButtonsView;
